module.exports = __webpack_public_path__ + "images/icons_v2/edit-filled-061f15e5.svg";